<template>
  <v-container fluid>
    <v-expansion-panel class="mb-3" inset v-model="open">
      <v-expansion-panel-content class="CSP_BoarderStyle">
        <template v-slot:actions>
          <v-icon large color="primary">
            $vuetify.icons.expand
          </v-icon>
        </template>

        <template v-slot:header>
          <div>
            <v-icon color="primary">search</v-icon>
            <span class="pl-2 subheading">
              Custom Search Panel
            </span>
          </div>
        </template>

        <v-layout row wrap align-center>
          <v-flex class="mx-5">
            <v-layout class="mx-5" row wrap align-center>
              <v-text-field
                label="Registration Number"
                v-model="searchParam.reg_no"
                prepend-icon="edit"
              />
            </v-layout>
          </v-flex>

          <v-flex xs12 sm12 md12 class="mb-3">
            <v-layout justify-center row fill-height align-center>
              <v-btn outline round large @click="getTClistDetails">
                <v-icon left dark>search</v-icon>
                Search
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-card color="white">
      <v-layout row>
        <v-card flat>
          <v-card-text class="title">
            TC Exception List
          </v-card-text>
        </v-card>
        <v-divider class="my-2" vertical />
        <v-spacer />
        <v-btn color="primary" @click="addNew()">Add New</v-btn>
      </v-layout>
    </v-card>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="getTCList.data"
      class="elevation-1"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
      :rows-per-page-items="pagination.rowsPerPageItems"
    >
      <template v-slot:items="props">
        <td>{{ props.item.rn }}</td>

        <td class="text-xs">
          {{ props.item.student.reg_no }}
        </td>

        <td class="text-xs">
          {{ props.item.student.name }}
        </td>

        <td class="text-xs">
          {{ props.item.reason }}
        </td>

        <td class="text-xs">
          {{ props.item.user.name }}
        </td>

        <td class="justify-center text-xs-center">
          <v-item-group>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  small
                  color="red"
                  v-on="on"
                  @click="deleteException(props.item.id)"
                >
                  <v-icon class="mr-0" color="white">
                    delete
                  </v-icon>
                </v-btn>
              </template>

              <span>Delete</span>
            </v-tooltip>
          </v-item-group>
        </td>
      </template>
    </v-data-table>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" max-width="600px" persistent hide-overlay>
        <template v-slot:activator="{ on }">
          <!-- <v-btn color="primary" dark v-on="on">Open Dialog</v-btn> -->
        </template>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Add New Exception</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn color="red" small dark fab @click="dialog = false"
                ><v-icon>close</v-icon></v-btn
              >
            </v-toolbar-items>
          </v-toolbar>

          <v-flex class="mx-12">
            <v-layout class="mx-5" row wrap align-center>
              <v-text-field
                label="Registration Number"
                v-model="reg_no"
                prepend-icon="edit"
              />
            </v-layout>
          </v-flex>
          <v-flex class="mx-12">
            <v-layout class="mx-5" row wrap align-center>
              <v-textarea
                v-model="reason"
                label="Label"
                outline
                prepend-icon="edit"
              ></v-textarea>
            </v-layout>
          </v-flex>

          <v-btn
            color="primary"
            @click="saveException(reg_no, reason)"
            style="margin-left:41%;"
            >Add New</v-btn
          >
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      open: 0,
      reg_no: "",
      reason: "",
      dialog: false,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsPerPageItems: [
          5,
          10,
          25,
          {
            text: "All",
            value: -1,
          },
        ],
        totalItems: 0,
        sortBy: "",
        descending: false,
      },

      totalDataItems: 0,

      loading: true,

      search: "",

      searchParam: {
        reg_no: "",
        page: 1,
        limit: 10,
        sort: "",
        search: "",
      },

      headers: [
        {
          text: "SL.",
          value: "rn",
          align: "left",
          sortable: false,
        },
        {
          text: "Registration Number",
          value: "reg_no",
          sortable: false,
        },
        {
          text: "Name",
          value: "name",
          sortable: false,
        },
        {
          text: "Reason",
          value: "reason",
          sortable: false,
        },
        {
          text: "Added By",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],

      degree: "",
    };
  },

  computed: {
    getTCList() {
      return (
        this.$store.getters.getTCExceptionData || {
          data: {
            data: [],
          },
          meta: {
            from: 0,
            total: 0,
          },
        }
      );
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getTClistDetails();
      },
      deep: true,
    },
  },

  created() {
    this.callPMSApi();
    this.searchParam.degree_code = this.degree;
  },

  methods: {
    setLimit() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      this.searchParam.page = page;
      this.searchParam.limit = rowsPerPage;
      this.searchParam.sort = sortBy;
      this.searchParam.search = this.search;
    },

    addNew() {
      this.dialog = true;
    },

    saveException(reg_no, reason) {
      let form = {
        reg_no: reg_no,
        reason: reason,
      };
      this.$store
        .dispatch("saveTCException", form)
        .then((response) => {
          console.log(response);
          this.getTClistDetails();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    callPMSApi() {
      const degree = JSON.parse(localStorage.getItem("loggedInExam"));
      this.degree = degree.degree_code;
    },

    getTClistDetails() {
      this.loading = true;

      this.setLimit();

      this.$store
        .dispatch("getTCExceptionListAdmin", this.searchParam)
        .then((data) => {
          this.loading = false;

          if (data && data.meta) {
            this.sl_count = data.meta.from;

            this.pagination.totalItems = data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;

          console.error("TC List API Error:", error);
        });
    },

    deleteException(id) {
      if (!id) {
        console.error("TC Exception ID not found");
        return;
      }

      if (!confirm("Are you sure you want to delete this TC Exception?")) {
        return;
      }

      this.$store
        .dispatch("deleteException", id)
        .then((response) => {
          console.log(response);

          this.getTClistDetails();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style></style>
